<!--
   英文状态下的谷歌地图
   -->
<template>
  <div id="map" style="background-color:#ccc;height:100%;" ref="googleMap" >
    <!--markers 验货员
               :center="{lng: center[0], lat: center[1]}"  自己的位置  在缓存中存在
    -->
  </div>
</template>

<script>
export default {
  name: "googleMapUserHome",
  data() {
    return {
        center:{lng:'',lat:''},
        map:''
    };
  },
  methods: {
    createGoogleMap() {
        // this.map = new google.maps.Map(document.getElementById("map"), {
        //     zoom: 5,
        //     center: this.center
        // });
        let that = this;
        var map = new google.maps.Map(document.getElementById("map"), {
            zoom: 5,
            center: this.center
        });
        //   The marker, positioned at Uluru
        var marker = new google.maps.Marker({
            position: this.center,
            icon: "http://www.inspector.ltd/red-circle.png",
            map: map,
        });

        if (Array.isArray(this.markers)) {
            that.markers.forEach((item, index) => {
            let marker = new google.maps.Marker({
                position: { lat: item.position[0], lng: item.position[1] },
                map: map,
            });
                marker.addListener("click", function () {});
            });
        }
    },
  },
  mounted() {
    this.center = this.myPos
    this.createGoogleMap();
  },
  watch: {
    myPos: {
      handler: function () {
        let that = this;
        /* setTimeout(function () {
          that.createGoogleMap();
        }, 500); */
      },
      deep: true,
    },
  },
  props: ["markers", "myPos"],
};
</script>

<style>
</style>